import React from 'react'
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  Avatar,
  Stack,
} from '@mui/material'
import {
  Close as CloseIcon,
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
} from '@mui/icons-material'

function TeamDialog({ open, onClose, darkMode }) {
  const team = [
    {
      name: 'Tushar Lone',
      role: 'Lead Developer, SupplyNetPy Library',
      description: 'PhD Scholar at Indian Institute of Technology (IIT) Goa, Core developer of the SupplyNetPy simulation engine',
      avatar: 'TL',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      github: 'https://github.com/tusharlone',
      linkedin: 'https://www.linkedin.com/in/tushar-lone-40097477/',
    },
    {
      name: 'Divyansh Pandey',
      role: 'Lead Developer, SupplyNet Web',
      description: 'B.Tech Final Year, SoSET Central University C.G.,   Full-stack developer of the SupplyNet Web platform',
      avatar: 'DP',
      color: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
      github: 'https://github.com/divyanshece',
      linkedin: 'https://www.linkedin.com/in/divyanshece/',
    },
  ]

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          bgcolor: darkMode ? '#1e293b' : '#fff',
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: darkMode ? '#94a3b8' : '#64748b',
          zIndex: 1,
          '&:hover': {
            bgcolor: darkMode ? '#334155' : '#f1f5f9',
            transform: 'rotate(90deg)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{
              mb: 1,
              color: darkMode ? '#fff' : '#0f172a',
            }}
          >
            Project Team
          </Typography>
          <Typography
            variant="body2"
            color={darkMode ? '#94a3b8' : '#64748b'}
          >
            Meet the people behind SupplyNet Web
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 3,
          }}
        >
          {team.map((member, index) => (
            <Card
              key={index}
              elevation={0}
              sx={{
                bgcolor: darkMode ? '#0f172a' : '#f8fafc',
                border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                borderRadius: 2,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  borderColor: '#3b82f6',
                  boxShadow: '0 8px 16px rgba(59,130,246,0.15)',
                },
              }}
            >
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    mx: 'auto',
                    mb: 2,
                    background: member.color,
                    fontSize: '2rem',
                    fontWeight: 700,
                  }}
                >
                  {member.avatar}
                </Avatar>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{
                    mb: 0.5,
                    color: darkMode ? '#fff' : '#0f172a',
                  }}
                >
                  {member.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 2,
                    color: '#3b82f6',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  {member.role}
                </Typography>
                <Typography
                  variant="body2"
                  color={darkMode ? '#94a3b8' : '#64748b'}
                  sx={{
                    mb: 2,
                    lineHeight: 1.5,
                    fontSize: '0.813rem',
                    minHeight: '60px',
                  }}
                >
                  {member.description}
                </Typography>
                <Stack direction="row" spacing={1} justifyContent="center">
                  <IconButton
                    size="small"
                    sx={{
                      bgcolor: darkMode ? '#334155' : '#e2e8f0',
                      color: darkMode ? '#e2e8f0' : '#475569',
                      '&:hover': {
                        bgcolor: '#3b82f6',
                        color: '#fff',
                      },
                    }}
                    onClick={() => window.open(member.github, '_blank')}
                  >
                    <GitHubIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    sx={{
                      bgcolor: darkMode ? '#334155' : '#e2e8f0',
                      color: darkMode ? '#e2e8f0' : '#475569',
                      '&:hover': {
                        bgcolor: '#0077b5',
                        color: '#fff',
                      },
                    }}
                    onClick={() => window.open(member.linkedin, '_blank')}
                  >
                    <LinkedInIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default TeamDialog